/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  modeMaintenance: false,
  baseEndpoint: 'https://api-node-mecsa.softgas.mx',
  baseEndpointPHP: 'https://api-php-mecsa.softgas.mx/api/v1',
  baseEndpointDev: 'https://softgas-dev.herokuapp.com',
  baseEndpointDevPHP: 'https://softgas-api-php-testing.herokuapp.com/api/v1',
  oldFilesApi: 'https://us-central1-amimegustalagasolina-1f93a.cloudfunctions.net/fileGenerator',
  urlReceipt: 'https://sandbox-dashboard.openpay.mx/paynet-pdf/mk85dwplbzajjx0dxbra',
  urlReceiptSpei: 'https://sandbox-dashboard.openpay.mx/spei-pdf/mk85dwplbzajjx0dxbra',
  firebase: {
    apiKey: "AIzaSyAYHdSvBgxCaVsaUqz2cYBNveaUQqSUa9o",
    authDomain: "softgas-mecsa.firebaseapp.com",
    projectId: "softgas-mecsa",
    storageBucket: "softgas-mecsa.appspot.com",
    messagingSenderId: "363190317398",
    appId: "1:363190317398:web:2fda44cabc3128696266f7",
    measurementId: "G-E7GWXWKM93",
    databaseURL: 'https://softgas-mecsa-default-rtdb.firebaseio.com',
  },
};
